import React from 'react';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import ContactView from './ContactView';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    padding: 0,
    margin: 15
  }
}));

const Contact = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Contact"
    >
      <Container maxWidth="lg">
        <Grid
          display="flex"
          justifyContent="flex-start"
          container
          spacing={3}
        >
          <Grid
            item
            lg={12}
            md={12}
            xs={12}
          >
            <ContactView />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Contact;
